<template>
	<div>
		<router-view />
	</div>
</template>

<script>
	import notopened from "components/tabledata/notopened";
	import {
		fn_getother,
		get_member,
	} from 'network/kh_public'
	export default {
		components: {
			notopened,
		},
		data() {
			return {
				pageshow: false,
				routlist: [{
						name: '销售简报',
						path: '/operate/briesale',
						show: true,
					},
					{
						name: '商机管理',
						path: '/operate/opportlist',
					},
					{
						name: '项目管理',
						path: '/operate/projectlist',
					},
					{
						name: '合同管理',
						path: '/operate/contractlist',
					},
					{
						name: '回款管理',
						path: '/operate/lectionlist',
					},
					{
						name: '订单管理',
						path: '/operate/orderlist',
						show: true,
					},
					{
						name: '报价单管理',
						path: '/operate/quotatlist',
						show: true,
					},

				],


			}
		},

		// 监听,当路由发生变化的时候执行
		watch: {
			$route(to, from) {
				this.setRouts(to.path)
			}
		},
		methods: {

			// 获取订单自定义
			getCustomFeatures(path) {
				let member_id = localStorage.member_id;
				get_member(member_id).then(res => {
					if (!this.$handlereq(res)) return
					console.log('\.get_member')
					// 用户功能自定义 参数
					if (path == '/operate/orderlist') {
						let order_config = res.result.order_config || '';
						localStorage.setItem('order_config', order_config);
					} else if (path == '/operate/quotatlist') {
						let quotation_config = res.result.quotation_config || '';
						localStorage.setItem('quotation_config', quotation_config);
					}

				})
			},
			// 
			setRouts(path) {
				let list = this.routlist
				for (let item of list) {

					if (item.path == '/operate/orderlist' || item.path == '/operate/quotatlist') {
						this.getCustomFeatures(item.path)
					}
					if (item.path == path) {
						if (item.show) {
							this.pageshow = true
						} else {
							this.pageshow = fn_getother(item.name)
						}
					}
					let strpath = (this.$route.path).slice(0, 18)
					if (strpath == '/operate/orderlist') {
						this.pageshow = true
					}

					let strpath2 = (this.$route.path).slice(0, 19)
					if (strpath2 == '/operate/quotatlist') {
						this.pageshow = true
					}
				}
			},

		},
		created() {
			let path = this.$route.path

			this.setRouts(path)
		},
	}
</script>

<!-- 
或者
// 监听,当路由发生变化的时候执行
watch: {
  $route: {
    handler: function(val, oldVal){
      console.log(val);
    },
    // 深度观察监听
    deep: true
  }
},
或者
// 监听,当路由发生变化的时候执行
watch: {
  '$route':'getPath'
},
methods: {
  getPath(){
    console.log(this.$route.path);
  }
} -->


<style scoped lang="scss">
</style>